// extracted by mini-css-extract-plugin
module.exports = {"Page":"Page-module--Page--3avkL"};